'use strict';

const _ = require('lodash');
const Slide = require('./slide');
const template = require('../templates/photo-slide.hbs');
const Fun = require('../fun');

module.exports = class extends Slide {
  constructor(context = {}) {
    super(template, context);
    this._maxHeight = 0;

    // attempt to set the max-height of the image by examining the image file,
    // this process is attempted twice, first when the image is loaded, then when it's rendered.
    // load event: https://davidwalsh.name/get-image-dimensions
    if (typeof context.photoUrl === 'undefined')
      console.error('photo url has not been set.');
    const img = new Image();
    img.addEventListener('load', () => {
      this._maxHeight = img.naturalHeight;
      if (!_.isEmpty(this.$el))
        this._attachMaxHeight();
    });
    img.src = context.photoUrl;
     _idletimer = _mainidletimer;
    this.domEvents = {
      //'mousemove': '_resetIdleTimer',
      'keydown':'_resetIdleTimer',
      'click': '_resetIdleTimer'
    };

    this.on('add', this._attachMaxHeight);
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
  }

  // SLIDE EVENTS

  _attachMaxHeight() {
    const $photo = this.$el.find('.photo-slide-photo');
    if (this._maxHeight > 0 && $photo.css('max-height') === 'none')
      $photo.css('max-height', this._maxHeight);
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    _idletimer = _mainidletimer;
  }
  _countdown() {
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    _idleintervalHandler = setInterval(() => {
      _idletimer -= 1;
      if(_idletimer <= 30){
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }
  _stopIdleTimer(){
    if(_idleintervalHandler != undefined){
      clearInterval(_idleintervalHandler);
    }
  }
};
